import { createAsyncThunk } from '@reduxjs/toolkit'
import selectedPlanRequest from 'src/api/requests/selectedFromLp'
import selectedPlanActions from 'src/store/domain/selectedFromLp/selectedDetail'

export const getSelectedPlan = createAsyncThunk<
  any,
  { user_treatment_id: any; with?: string[] }
>('get_selected_plan', async (params, { dispatch }) => {
  try {
    dispatch(selectedPlanActions.updateLoading(true))
    const queryParams = new URLSearchParams()
    queryParams.append('user_treatment_id', String(params.user_treatment_id))

    if (Array.isArray(params.with)) {
      params.with.forEach((item) => queryParams.append('with[]', item))
    }
    const res = await selectedPlanRequest.getSelectedPlan(params)
    if (res.data) {
      dispatch(selectedPlanActions.updateEntity(res.data.data))
    }
    dispatch(selectedPlanActions.updateLoading(false))
  } catch (error) {
    dispatch(selectedPlanActions.updateLoading(false))
  }
})
